import { gh, isExecute, vueDefineComponent } from '@syncfusion/ej2-vue-base';
import { isNullOrUndefined } from '@syncfusion/ej2-base';
export let CategoriesDirective = vueDefineComponent({
    inject: { custom: { default: null } },
    render(createElement) {
        if (!isExecute) {
            let h = !isExecute ? gh : createElement;
            let slots = null;
            if (!isNullOrUndefined(this.$slots.default)) {
                slots = !isExecute ? this.$slots.default() : this.$slots.default;
            }
            return h('div', { class: 'e-directive' }, slots);
        }
        return;
    },
    updated() {
        if (!isExecute && this.custom) {
            this.custom();
        }
    },
    methods: {
        getTag() {
            return 'e-categories';
        }
    }
});
export const CategoriesPlugin = {
    name: 'e-categories',
    install(Vue) {
        Vue.component(CategoriesPlugin.name, CategoriesDirective);
    }
};
export let CategoryDirective = vueDefineComponent({
    render() {
        return;
    },
    methods: {
        getTag() {
            return 'e-category';
        }
    }
});
export const CategoryPlugin = {
    name: 'e-category',
    install(Vue) {
        Vue.component(CategoryPlugin.name, CategoryDirective);
    }
};
